<template>
    <div>
        <TitleBar>
            <template v-slot:title><translate>Supplier Insight</translate></template>
            <template v-slot:buttons>
                <GekkoButton 
                    :text="$gettext('All reports')"
                    :to="{ name: 'Reports' }"
                    icon="fa fa-chart-column"
                />
            </template>
        </TitleBar>
        <div class="content">
            <div v-if="!$store.getters['getIsPremium']" class="gk-tip gk-tip--warning gk-tip--caution my-4" :style="tipCssVars">
                <span v-translate>This report is based on fake data, please feel free to play with it and </span>
                <a href="/en/subscriptions/manage/">{{ $gettext("upgrade to premium.") }}</a>
            </div>

            <FilterBar
                cookieName="SupplierInsightFilterOptionsVue"
                :mainFilters="['DateRangeFilter']"
                filterBarType="supplier-insight"
                @change="filtersChanged"
            >
            <template v-slot:right-bar>
            <TotalAmountsSupplier :num-format="'euro'" />
            </template>
            </FilterBar>    

            <SupplierCostsTable :customers="customers" :filters="filters" />
        </div>
    </div>
</template>

<script>
import TitleBar from "@/components/TitleBar"
import GekkoButton from "@/components/GekkoButton"
import SupplierCostsTable from "@/components/customer_insight/SupplierCostsTable"
import CustomerService from "@/store/services/customer.service"
import FilterBar from "@/components/list_filters/FilterBar"
import TotalAmountsSupplier from "@/components/suppliers/TotalAmountsSupplier.vue"

export default {
    name: "SupplierInsight",
    components: {TitleBar, GekkoButton, SupplierCostsTable, FilterBar, TotalAmountsSupplier},
    data() {
        return {
            customers: [],
            filters: {}
        }
    },
    created() {
        CustomerService.list({is_supplier: true}).then((response) => {
            this.customers = response.data
        })
    },
    methods: {
        filtersChanged(filters) {
            this.filters = JSON.parse(JSON.stringify(filters))

            if ('report_option' in filters && filters.report_option != null) {
                this.selectedReport = filters.report_option
            }
        }
    },
    computed: {
        tipCssVars() {
            return `--cautiontext: '${ this.$gettext('Gekko premium tip') }'`
        }
    }
}
</script>

<style scoped>

</style>